import {
  ALL_BAZAAR_LIST_FAILURE,
  ALL_BAZAAR_LIST_REQUEST,
  ALL_BAZAAR_LIST_SUCCESS,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const fetchAllBazaarListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_BAZAAR_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case ALL_BAZAAR_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "list uploaded successfully",
      };

    case ALL_BAZAAR_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to update bazaar list",
      };

    default:
      return state;
  }
};

export default fetchAllBazaarListReducer;
